// Ficha de producto: suma al selector de talla las tallas de los productos hermanados
// (custom.rep = "Hermanar tallaje"). Los datos los renderiza snippets/moddo-tallaje-hermanado.liquid
// en un <template class="hermanados-tallas-template"> dentro del fieldset de talla.
//
// Cada talla hermanada es un radio con el mismo name/form que las tallas del producto, así que el
// navegador los hace excluyentes. Su change NO sube a <variant-selects> (no es una variante de este
// producto): aquí se fija el variant id del producto hermanado en el formulario de compra.

(function () {
  function initTemplate(template) {
    if (template.dataset.initialized) return;
    template.dataset.initialized = 'true';

    const fieldset = template.closest('fieldset');
    const variantSelects = template.closest('variant-selects');
    if (!fieldset || !variantSelects) return;

    const mainRadios = [...fieldset.querySelectorAll('input[type="radio"]')];
    const sample = mainRadios[0];
    if (!sample) return;

    // Al elegir una talla del producto principal se restaura su galería.
    variantSelects.addEventListener('change', () => restoreGallery(variantSelects));

    const taken = new Set(mainRadios.map(r => r.value.trim()));
    const section = variantSelects.dataset.section;
    // custom.oth: 'start' = antes de las tallas del producto, 'end' = después.
    const atStart = template.dataset.position === 'start';
    const firstMainInput = sample;

    for (const entry of template.content.querySelectorAll('[data-variant-id]')) {
      const size = entry.dataset.size;
      if (taken.has(size.trim())) continue;
      taken.add(size.trim());

      const id = `${section}-hermanado-${entry.dataset.variantId}`;
      const input = document.createElement('input');
      input.type = 'radio';
      input.id = id;
      input.name = sample.name;
      input.value = size;
      input.setAttribute('form', sample.getAttribute('form') || entry.dataset.form);
      input.dataset.hermanadoVariantId = entry.dataset.variantId;
      input.dataset.hermanadoProductUrl = entry.dataset.productUrl;
      input.dataset.available = entry.dataset.available;
      if (entry.dataset.available !== 'true') {
        input.disabled = true;
        input.classList.add('is-disabled');
      }

      const label = document.createElement('label');
      label.setAttribute('for', id);
      label.title = entry.dataset.productTitle;
      label.innerHTML = `<span></span>`;
      label.firstChild.textContent = size;

      input.addEventListener('change', event => {
        event.stopPropagation();
        selectHermanado(variantSelects, fieldset, input);
      });

      if (atStart) {
        fieldset.insertBefore(input, firstMainInput);
        fieldset.insertBefore(label, firstMainInput);
      } else {
        fieldset.appendChild(input);
        fieldset.appendChild(label);
      }
    }
  }

  function selectHermanado(variantSelects, fieldset, input) {
    variantSelects.dataset.confirmed = 'true';

    const value = fieldset.querySelector('.form__label__value');
    if (value) value.textContent = input.value;

    const forms = document.querySelectorAll(
      `#product-form-${variantSelects.dataset.section}, #product-form-installment, #product-form-sticky-${variantSelects.dataset.section}`
    );
    forms.forEach(form => {
      const idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;
      idInput.value = input.dataset.hermanadoVariantId;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    variantSelects.removeErrorMessage?.();
    variantSelects.toggleAddButton?.(false, '', false);

    swapGallery(variantSelects, input.dataset.hermanadoProductUrl, input.dataset.hermanadoVariantId);
  }

  // Galería: al elegir una talla hermanada se sustituyen las fotos por las del producto relacionado
  // (se pide su sección y se reemplaza #MediaGallery); al volver a una talla propia se restaura.
  const galleryHtmlCache = new Map();

  function destroySlider(gallery) {
    const slider = gallery.querySelector('product-slider');
    if (slider && slider.flkty) slider.flkty.destroy();
  }

  // variant-selects guarda la referencia al <product-slider> en su constructor; hay que refrescarla.
  function refreshSliderRef(variantSelects, gallery) {
    variantSelects.productSlider = gallery.querySelector('.product-images');
  }

  async function swapGallery(variantSelects, productUrl, variantId) {
    const section = variantSelects.dataset.section;
    const gallery = document.getElementById(`MediaGallery-${section}`);
    if (!gallery || !productUrl) return;
    if (variantSelects._galleryUrl === productUrl) return;

    const url = `${productUrl}?variant=${variantId}&section_id=${section}`;
    let html = galleryHtmlCache.get(url);
    try {
      if (!html) {
        const res = await fetch(url);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        html = doc.getElementById(`MediaGallery-${section}`)?.innerHTML;
        if (!html) throw new Error('Sin galería en la respuesta');
        galleryHtmlCache.set(url, html);
      }
    } catch (err) {
      console.error('Error cargando fotos del producto hermanado:', err);
      return;
    }

    // Si mientras tanto se eligió otra talla, no pisar.
    const checked = variantSelects.querySelector('input[data-hermanado-variant-id]:checked');
    if (!checked || checked.dataset.hermanadoProductUrl !== productUrl) return;

    destroySlider(gallery);
    if (variantSelects._galleryOriginal === undefined) variantSelects._galleryOriginal = gallery.innerHTML;
    gallery.innerHTML = html;
    variantSelects._galleryUrl = productUrl;
    refreshSliderRef(variantSelects, gallery);
  }

  function restoreGallery(variantSelects) {
    if (variantSelects._galleryOriginal === undefined) return;
    const gallery = document.getElementById(`MediaGallery-${variantSelects.dataset.section}`);
    if (!gallery) return;
    destroySlider(gallery);
    gallery.innerHTML = variantSelects._galleryOriginal;
    variantSelects._galleryOriginal = undefined;
    variantSelects._galleryUrl = null;
    refreshSliderRef(variantSelects, gallery);
  }

  function initAll() {
    document.querySelectorAll('template.hermanados-tallas-template').forEach(initTemplate);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll();
    // Quick view y otros paneles inyectan la ficha después de la carga.
    new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
  });
})();
